import { jsx as _jsx } from "react/jsx-runtime";
import { Handle, Position } from 'reactflow';
import { FaCaretRight, FaCaretLeft, FaCaretUp, FaCaretDown } from 'react-icons/fa';
// Custom handle components with icons
export const CustomTargetHandle = ({ position, id, className, style, active = true, connected = false }) => {
    const getArrowIcon = () => {
        switch (position) {
            case Position.Top:
                return _jsx(FaCaretDown, {});
            case Position.Bottom:
                return _jsx(FaCaretUp, {});
            case Position.Left:
                return _jsx(FaCaretRight, {});
            case Position.Right:
                return _jsx(FaCaretLeft, {});
            default:
                return _jsx(FaCaretDown, {});
        }
    };
    return (_jsx(Handle, { type: "target", position: position, id: id, className: `custom-target-handle ${connected ? 'connected' : ''} ${className || ''} ${active ? 'active' : 'inactive'}`, style: style, children: _jsx("div", { className: "handle-icon target-icon", children: getArrowIcon() }) }));
};
export const CustomSourceHandle = ({ position, id, className, style, active = true, connected = false }) => {
    const getArrowIcon = () => {
        switch (position) {
            case Position.Top:
                return _jsx(FaCaretUp, {});
            case Position.Bottom:
                return _jsx(FaCaretDown, {});
            case Position.Left:
                return _jsx(FaCaretLeft, {});
            case Position.Right:
                return _jsx(FaCaretRight, {});
            default:
                return _jsx(FaCaretRight, {});
        }
    };
    return (_jsx(Handle, { type: "source", position: position, id: id, className: `custom-source-handle ${connected ? 'connected' : ''} ${className || ''} ${active ? 'active' : 'inactive'}`, style: style, children: _jsx("div", { className: "handle-icon source-icon", children: getArrowIcon() }) }));
};
